import { AnimatedSprite, BaseTexture, Texture, Rectangle } from "pixi.js";

export function createSprite(jsonframes, baseTxt) {
  let frames = Object.values(jsonframes);
  let textures = frames.map((fr) => {
    const { x, y, w, h } = fr.frame;
    const txt = new Texture(baseTxt, new Rectangle(x, y, w, h));
    return txt;
  });
  let sprite = new AnimatedSprite(textures);
  sprite.anchor.set(0.5, 0.5);
  sprite.loop = true;

  return sprite;
}
